<template>
  <v-dialog content-class="settings-window" width="600px" v-model="visible" v-click-outside="close" autofocus >
    <v-card id="settings">
      <v-layout row wrap>
        <!-- left tabs -->
        <v-flex class="sets--left">
          <v-toolbar color="transparent" dense flat>
            <v-btn icon @click="close">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{$t('drawer_settings')}}</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>

          <div class="tab-item-wrapper" style="height:100vh;">
            <v-list class="pa-0">
              <template v-for="(item, index) in items">
                <v-list-tile :key="index"  @click="onItemClicked(index)" >
                  <v-icon medium v-html="item.icon"></v-icon>
                  <v-list-tile-content style="margin-left:16px;">
                    <v-list-tile-title class="list-item-title" ><v-layout align-center fill-height><div style="line-height: 24px !important;">{{item.title}}</div></v-layout></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider :key="index+1000"/>
              </template>
            </v-list>
          </div>
        </v-flex>

        <!-- right tab container -->
        <v-flex class="sets--right">
          <div class="scrollable">
            <ViewSettings v-if="viewVisible" />
            <SecuritySettings v-if="securityVisible" />
            <AudioSettings v-if="audioVisible" />
            <BackupsSettings v-if="backupVisible" />
            <BlockedContacts v-if="blacklistVisible" ref="blacklist"/>
            <Language v-if="languageVisible" />
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script> 
  import SecuritySettings from '@settings/SecuritySettings.vue'
  import AudioSettings from '@settings/AudioSettings.vue'
  import BackupsSettings from '@settings/BackupsSettings.vue'
  import Language from '@settings/Language.vue'
  import ViewSettings from '@settings/ViewSettings.vue'
  import BlockedContacts from './BlockedContacts.vue'

  export default {
    name: 'settings',
    data () {
      return {
        viewVisible: true,
        securityVisible: false,
        audioVisible: false,
        backupVisible: false,
        blacklistVisible: false,
        languageVisible: false,
        items:[
          {title: this.$t('settings_view'), icon: 'format_paint'},
          {title: this.$t('media_type_audio'), icon: 'audiotrack'},
          {title: this.$t('settings_menu_security'), icon: 'security'},
          {title: this.$t('settings_backups'), icon: 'backup'},
          {title: this.$t('settings_language'), icon: 'language'},
          {title: this.$t('settings_blacklist'), icon: 'block'}
        ]
      }
    },
    components: {
      SecuritySettings, 
      BackupsSettings, 
      AudioSettings, 
      BlockedContacts, 
      Language, 
      ViewSettings 
    },
    props: {
      visible: {
        type: Boolean, 
        default: false
      }
    },
    methods: {
      onItemClicked(index) {
        this.viewVisible = (index == 0)
        this.audioVisible = (index == 1)
        this.securityVisible = (index == 2)
        this.backupVisible = (index == 3)
        this.languageVisible = (index == 4)
        this.blacklistVisible = (index == 5)
      },
      close() {
        if (!this.visible)
          return
        // notify parent
        this.$emit('update:visible', false)
      },
      contactBlocked(contactId) {
        if (this.$refs.blacklist)
          this.$refs.blacklist.contactBlocked(contactId) 
      },
      contactUnblocked(contactId) {
        if (this.$refs.blacklist)
          this.$refs.blacklist.contactUnblocked(contactId)
      }
    }
  }
</script>

<style>
  #settings .sets--left {
    width: 230px;
    border-right-width:thin;
    border-right-style:solid;
    border-right-color: var(--divider-color);
  }

  #settings .sets--right {
    width: calc(100% - 230px);
    max-height: 450px !important;
    height: 450px !important;
    display: flex;
    flex-direction: column;    
  }
  #settings .sets--right .scrollable {
    box-sizing: content-box;
    overflow-y: auto;
    width: 100%;  
  }

  #settings .devider {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .settings-window {
    overflow:  hidden !important;
    max-height: 450px !important;
    height: 450px !important;
  }

  #settings .list-item-title {
      height: 48px !important;
      white-space: pre-wrap !important;
  }

</style>